import { j as a } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as l } from "../../../../IconBase-CxZyIWw2.js";
const s = i((e, o) => /* @__PURE__ */ a.jsx(
  l,
  {
    ref: o,
    ...e,
    image: (r) => /* @__PURE__ */ a.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...r,
        children: /* @__PURE__ */ a.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M18 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-6 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0m10 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0m9-11a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6 18a3 3 0 1 0 0-6 3 3 0 0 0 0 6M26 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4M8 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0m18 24a4 4 0 1 0 0-8 4 4 0 0 0 0 8",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
s.displayName = "FadeDarkCirclesIcon";
export {
  s as FadeDarkCirclesIcon,
  s as default
};
//# sourceMappingURL=index.js.map
